module.exports = __webpack_public_path__ + "img/block_2.56dc3ff4.png";